// ControlDropDownFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService           from 'FactoryService.js';
import constants                from 'Constants.js';
import sequenceService          from 'SequenceService.js';

import ControlModel             from 'ControlModel.js'
import DropDownControlView      from 'common-inputs/DropDownControlView.js';


class ControlDropDownFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.gridData = [{value: '1', selected: 'selected', caption: 'Item 1'}, {value: '2', caption: 'Item 2'}, {value: '3', caption: 'Item 3'}];
        attributes.styleColorText ='~inputTextColor';
        attributes.fontFamily = '~inputFont';
        attributes.fontSize = '~inputFont';
        attributes.textWeight = '~inputFont';
        attributes.textStyle  = '~inputFont';
        attributes.borderStyle= 'solid';
        attributes.borderSize= '1';
        attributes.cornerRadius= '2';
        attributes.borderColor = '~inputBorderColor';
        attributes.styleBGColorText = '~inputBgColor';
        attributes.backgroundColor = '~inputBgColor';
        attributes.selectFields = [{id: attributes.id + '$v' ,text: 'Value'}, {id:attributes.id, text: 'Caption'}];
        attributes.selectedIndex = '0';
        attributes.resizePadding = 2;
        attributes.Property = [{_id: 'captions', Item: [{_value: 'Item 1'}, {_value: 'Item 2'}, {_value: 'Item 3'}]}, {_id: 'values', Item: [{_value: '1'}, {_value: '2'}, {_value: '3'} ]}];
		attributes.minWidth = 25;
		attributes.lowestHeight = 10;
        this.resolveForInitialMinHeight(attributes);
        attributes.translateProps = [
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
        ];

        const view = new DropDownControlView( {
            model: new ControlModel( attributes ),  
            el: $(constants.FORM_ID),
            pos: pos, 
            factoryKey: factoryKey, 
            id: attributes.id
        });

        return view;
    }

}

const controlDropDownFactory = new ControlDropDownFactory();

export default controlDropDownFactory;